import { ApiReportEditableFields } from "../models/api/report";
import { useAuthenticatedGigApiFetcher } from "./common/fetching";

export const useCreateReport = () => useAuthenticatedGigApiFetcher<ApiReportEditableFields, string, ApiReportEditableFields>("POST",
    ( dto) => ({
        url: "api/reports/",
        body: dto
    })
);